export default "__VITE_PUBLIC_ASSET__391604b2__"